// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateOrderDTO } from '../models';
import { CreateTenancyRequestDTO } from '../models';
import { PolicyDocumentDTO } from '../models';
import { TenancyDTO } from '../models';
import { TenancyWithCheckoutAndClaimDTO } from '../models';
import { TenantMoveOutInfoResponseDTO } from '../models';
import { TenantScheduledMoveOutRequestDTO } from '../models';
import { TenantScheduledMoveOutResponseDTO } from '../models';
import { UpdateClosingRemindersEnabledRequestDTO } from '../models';
import { UpdateExistingPropertyOnTenancyRequestDTO } from '../models';
import { UpdatePropertyRequestDTO } from '../models';
import { UpdateTenancyRequestDTO } from '../models';
/**
 * TenanciesApi - axios parameter creator
 * @export
 */
export const TenanciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update closing reminders enabled on a tenancy
         * @param {string} id Tenancy id
         * @param {UpdateClosingRemindersEnabledRequestDTO} updateClosingRemindersEnabledRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closingRemindersEnabled(id: string, updateClosingRemindersEnabledRequestDTO: UpdateClosingRemindersEnabledRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling closingRemindersEnabled.');
            }
            // verify required parameter 'updateClosingRemindersEnabledRequestDTO' is not null or undefined
            if (updateClosingRemindersEnabledRequestDTO === null || updateClosingRemindersEnabledRequestDTO === undefined) {
                throw new RequiredError('updateClosingRemindersEnabledRequestDTO','Required parameter updateClosingRemindersEnabledRequestDTO was null or undefined when calling closingRemindersEnabled.');
            }
            const localVarPath = `/v2/tenancies/{id}/closing-reminders-enabled`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateClosingRemindersEnabledRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateClosingRemindersEnabledRequestDTO !== undefined ? updateClosingRemindersEnabledRequestDTO : {}) : (updateClosingRemindersEnabledRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Tenancy
         * @param {CreateTenancyRequestDTO} createTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancy(createTenancyRequestDTO: CreateTenancyRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createTenancyRequestDTO' is not null or undefined
            if (createTenancyRequestDTO === null || createTenancyRequestDTO === undefined) {
                throw new RequiredError('createTenancyRequestDTO','Required parameter createTenancyRequestDTO was null or undefined when calling createTenancy.');
            }
            const localVarPath = `/v2/tenancies`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateTenancyRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createTenancyRequestDTO !== undefined ? createTenancyRequestDTO : {}) : (createTenancyRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Tenancy Order
         * @param {string} id Tenancy id
         * @param {CreateOrderDTO} createOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyOrder(id: string, createOrderDTO: CreateOrderDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createTenancyOrder.');
            }
            // verify required parameter 'createOrderDTO' is not null or undefined
            if (createOrderDTO === null || createOrderDTO === undefined) {
                throw new RequiredError('createOrderDTO','Required parameter createOrderDTO was null or undefined when calling createTenancyOrder.');
            }
            const localVarPath = `/v2/tenancies/{id}/orders`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateOrderDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createOrderDTO !== undefined ? createOrderDTO : {}) : (createOrderDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable Top Ups on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTopUps(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling disableTopUps.');
            }
            const localVarPath = `/v2/tenancies/{id}/disable-top-ups`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Extend outcome deadline
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendOutcomeDeadline(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling extendOutcomeDeadline.');
            }
            const localVarPath = `/v2/tenancies/{id}/extend-outcome-deadline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Tenancy By Id
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTenancyById.');
            }
            const localVarPath = `/v2/tenancies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all documents on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyDocuments(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTenancyDocuments.');
            }
            const localVarPath = `/v2/tenancies/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish products on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling publish.');
            }
            const localVarPath = `/v2/tenancies/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign addendum on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendumForSupplier(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling signAddendumForSupplier.');
            }
            const localVarPath = `/v2/tenancies/{id}/sign-addendum`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Look up move-out flow context for a tenancy token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantMoveOutInfo(token: string, options: any = {}): RequestArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling tenantMoveOutInfo.');
            }
            const localVarPath = `/v2/tenancies/tenant-move-out-info`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Tenant submitted a planned move-out date
         * @param {TenantScheduledMoveOutRequestDTO} tenantScheduledMoveOutRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO: TenantScheduledMoveOutRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenantScheduledMoveOutRequestDTO' is not null or undefined
            if (tenantScheduledMoveOutRequestDTO === null || tenantScheduledMoveOutRequestDTO === undefined) {
                throw new RequiredError('tenantScheduledMoveOutRequestDTO','Required parameter tenantScheduledMoveOutRequestDTO was null or undefined when calling tenantScheduledMoveOut.');
            }
            const localVarPath = `/v2/tenancies/tenant-scheduled-move-out`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"TenantScheduledMoveOutRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tenantScheduledMoveOutRequestDTO !== undefined ? tenantScheduledMoveOutRequestDTO : {}) : (tenantScheduledMoveOutRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Tenant confirming they have vacated
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantVacated(token: string, options: any = {}): RequestArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling tenantVacated.');
            }
            const localVarPath = `/v2/tenancies/tenant-vacated`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing Property details (address or landlord) on a Tenancy
         * @param {string} id Tenancy id
         * @param {UpdateExistingPropertyOnTenancyRequestDTO} updateExistingPropertyOnTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingProperty(id: string, updateExistingPropertyOnTenancyRequestDTO: UpdateExistingPropertyOnTenancyRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateExistingProperty.');
            }
            // verify required parameter 'updateExistingPropertyOnTenancyRequestDTO' is not null or undefined
            if (updateExistingPropertyOnTenancyRequestDTO === null || updateExistingPropertyOnTenancyRequestDTO === undefined) {
                throw new RequiredError('updateExistingPropertyOnTenancyRequestDTO','Required parameter updateExistingPropertyOnTenancyRequestDTO was null or undefined when calling updateExistingProperty.');
            }
            const localVarPath = `/v2/tenancies/{id}/properties`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateExistingPropertyOnTenancyRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateExistingPropertyOnTenancyRequestDTO !== undefined ? updateExistingPropertyOnTenancyRequestDTO : {}) : (updateExistingPropertyOnTenancyRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the Property On Tenancy
         * @param {string} id Tenancy id
         * @param {UpdatePropertyRequestDTO} updatePropertyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProperty(id: string, updatePropertyRequestDTO: UpdatePropertyRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateProperty.');
            }
            // verify required parameter 'updatePropertyRequestDTO' is not null or undefined
            if (updatePropertyRequestDTO === null || updatePropertyRequestDTO === undefined) {
                throw new RequiredError('updatePropertyRequestDTO','Required parameter updatePropertyRequestDTO was null or undefined when calling updateProperty.');
            }
            const localVarPath = `/v2/tenancies/{id}/properties`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdatePropertyRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updatePropertyRequestDTO !== undefined ? updatePropertyRequestDTO : {}) : (updatePropertyRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Tenancy
         * @param {string} id Tenancy id
         * @param {UpdateTenancyRequestDTO} updateTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancy(id: string, updateTenancyRequestDTO: UpdateTenancyRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTenancy.');
            }
            // verify required parameter 'updateTenancyRequestDTO' is not null or undefined
            if (updateTenancyRequestDTO === null || updateTenancyRequestDTO === undefined) {
                throw new RequiredError('updateTenancyRequestDTO','Required parameter updateTenancyRequestDTO was null or undefined when calling updateTenancy.');
            }
            const localVarPath = `/v2/tenancies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateTenancyRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateTenancyRequestDTO !== undefined ? updateTenancyRequestDTO : {}) : (updateTenancyRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenanciesApi - functional programming interface
 * @export
 */
export const TenanciesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Update closing reminders enabled on a tenancy
         * @param {string} id Tenancy id
         * @param {UpdateClosingRemindersEnabledRequestDTO} updateClosingRemindersEnabledRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closingRemindersEnabled(id: string, updateClosingRemindersEnabledRequestDTO: UpdateClosingRemindersEnabledRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).closingRemindersEnabled(id, updateClosingRemindersEnabledRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a Tenancy
         * @param {CreateTenancyRequestDTO} createTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancy(createTenancyRequestDTO: CreateTenancyRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).createTenancy(createTenancyRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a Tenancy Order
         * @param {string} id Tenancy id
         * @param {CreateOrderDTO} createOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyOrder(id: string, createOrderDTO: CreateOrderDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).createTenancyOrder(id, createOrderDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Disable Top Ups on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTopUps(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).disableTopUps(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Extend outcome deadline
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendOutcomeDeadline(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).extendOutcomeDeadline(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Tenancy By Id
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyWithCheckoutAndClaimDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).getTenancyById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Fetch all documents on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyDocuments(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyDocumentDTO>> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).getTenancyDocuments(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Publish products on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).publish(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sign addendum on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendumForSupplier(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).signAddendumForSupplier(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Look up move-out flow context for a tenancy token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantMoveOutInfo(token: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantMoveOutInfoResponseDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).tenantMoveOutInfo(token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Tenant submitted a planned move-out date
         * @param {TenantScheduledMoveOutRequestDTO} tenantScheduledMoveOutRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO: TenantScheduledMoveOutRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantScheduledMoveOutResponseDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Tenant confirming they have vacated
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantVacated(token: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).tenantVacated(token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update existing Property details (address or landlord) on a Tenancy
         * @param {string} id Tenancy id
         * @param {UpdateExistingPropertyOnTenancyRequestDTO} updateExistingPropertyOnTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingProperty(id: string, updateExistingPropertyOnTenancyRequestDTO: UpdateExistingPropertyOnTenancyRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).updateExistingProperty(id, updateExistingPropertyOnTenancyRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update the Property On Tenancy
         * @param {string} id Tenancy id
         * @param {UpdatePropertyRequestDTO} updatePropertyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProperty(id: string, updatePropertyRequestDTO: UpdatePropertyRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).updateProperty(id, updatePropertyRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a Tenancy
         * @param {string} id Tenancy id
         * @param {UpdateTenancyRequestDTO} updateTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancy(id: string, updateTenancyRequestDTO: UpdateTenancyRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).updateTenancy(id, updateTenancyRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenanciesApi - factory interface
 * @export
 */
export const TenanciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Update closing reminders enabled on a tenancy
         * @param {string} id Tenancy id
         * @param {UpdateClosingRemindersEnabledRequestDTO} updateClosingRemindersEnabledRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closingRemindersEnabled(id: string, updateClosingRemindersEnabledRequestDTO: UpdateClosingRemindersEnabledRequestDTO, options?: any) {
            return TenanciesApiFp(configuration).closingRemindersEnabled(id, updateClosingRemindersEnabledRequestDTO, options)(axios, basePath);
        },
        /**
         * Create a Tenancy
         * @param {CreateTenancyRequestDTO} createTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancy(createTenancyRequestDTO: CreateTenancyRequestDTO, options?: any) {
            return TenanciesApiFp(configuration).createTenancy(createTenancyRequestDTO, options)(axios, basePath);
        },
        /**
         * Create a Tenancy Order
         * @param {string} id Tenancy id
         * @param {CreateOrderDTO} createOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyOrder(id: string, createOrderDTO: CreateOrderDTO, options?: any) {
            return TenanciesApiFp(configuration).createTenancyOrder(id, createOrderDTO, options)(axios, basePath);
        },
        /**
         * Disable Top Ups on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTopUps(id: string, options?: any) {
            return TenanciesApiFp(configuration).disableTopUps(id, options)(axios, basePath);
        },
        /**
         * Extend outcome deadline
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendOutcomeDeadline(id: string, options?: any) {
            return TenanciesApiFp(configuration).extendOutcomeDeadline(id, options)(axios, basePath);
        },
        /**
         * Get a Tenancy By Id
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyById(id: string, options?: any) {
            return TenanciesApiFp(configuration).getTenancyById(id, options)(axios, basePath);
        },
        /**
         * Fetch all documents on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyDocuments(id: string, options?: any) {
            return TenanciesApiFp(configuration).getTenancyDocuments(id, options)(axios, basePath);
        },
        /**
         * Publish products on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(id: string, options?: any) {
            return TenanciesApiFp(configuration).publish(id, options)(axios, basePath);
        },
        /**
         * Sign addendum on a tenancy
         * @param {string} id Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendumForSupplier(id: string, options?: any) {
            return TenanciesApiFp(configuration).signAddendumForSupplier(id, options)(axios, basePath);
        },
        /**
         * Look up move-out flow context for a tenancy token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantMoveOutInfo(token: string, options?: any) {
            return TenanciesApiFp(configuration).tenantMoveOutInfo(token, options)(axios, basePath);
        },
        /**
         * Tenant submitted a planned move-out date
         * @param {TenantScheduledMoveOutRequestDTO} tenantScheduledMoveOutRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO: TenantScheduledMoveOutRequestDTO, options?: any) {
            return TenanciesApiFp(configuration).tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO, options)(axios, basePath);
        },
        /**
         * Tenant confirming they have vacated
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantVacated(token: string, options?: any) {
            return TenanciesApiFp(configuration).tenantVacated(token, options)(axios, basePath);
        },
        /**
         * Update existing Property details (address or landlord) on a Tenancy
         * @param {string} id Tenancy id
         * @param {UpdateExistingPropertyOnTenancyRequestDTO} updateExistingPropertyOnTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingProperty(id: string, updateExistingPropertyOnTenancyRequestDTO: UpdateExistingPropertyOnTenancyRequestDTO, options?: any) {
            return TenanciesApiFp(configuration).updateExistingProperty(id, updateExistingPropertyOnTenancyRequestDTO, options)(axios, basePath);
        },
        /**
         * Update the Property On Tenancy
         * @param {string} id Tenancy id
         * @param {UpdatePropertyRequestDTO} updatePropertyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProperty(id: string, updatePropertyRequestDTO: UpdatePropertyRequestDTO, options?: any) {
            return TenanciesApiFp(configuration).updateProperty(id, updatePropertyRequestDTO, options)(axios, basePath);
        },
        /**
         * Update a Tenancy
         * @param {string} id Tenancy id
         * @param {UpdateTenancyRequestDTO} updateTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancy(id: string, updateTenancyRequestDTO: UpdateTenancyRequestDTO, options?: any) {
            return TenanciesApiFp(configuration).updateTenancy(id, updateTenancyRequestDTO, options)(axios, basePath);
        },
    };
};

/**
 * TenanciesApi - interface
 * @export
 * @interface TenanciesApi
 */
export interface TenanciesApiInterface {
    /**
     * Update closing reminders enabled on a tenancy
     * @param {string} id Tenancy id
     * @param {UpdateClosingRemindersEnabledRequestDTO} updateClosingRemindersEnabledRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    closingRemindersEnabled(id: string, updateClosingRemindersEnabledRequestDTO: UpdateClosingRemindersEnabledRequestDTO, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Create a Tenancy
     * @param {CreateTenancyRequestDTO} createTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    createTenancy(createTenancyRequestDTO: CreateTenancyRequestDTO, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Create a Tenancy Order
     * @param {string} id Tenancy id
     * @param {CreateOrderDTO} createOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    createTenancyOrder(id: string, createOrderDTO: CreateOrderDTO, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Disable Top Ups on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    disableTopUps(id: string, options?: any): AxiosPromise<{}>;

    /**
     * Extend outcome deadline
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    extendOutcomeDeadline(id: string, options?: any): AxiosPromise<{}>;

    /**
     * Get a Tenancy By Id
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    getTenancyById(id: string, options?: any): AxiosPromise<TenancyWithCheckoutAndClaimDTO>;

    /**
     * Fetch all documents on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    getTenancyDocuments(id: string, options?: any): AxiosPromise<Array<PolicyDocumentDTO>>;

    /**
     * Publish products on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    publish(id: string, options?: any): AxiosPromise<{}>;

    /**
     * Sign addendum on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    signAddendumForSupplier(id: string, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Look up move-out flow context for a tenancy token
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    tenantMoveOutInfo(token: string, options?: any): AxiosPromise<TenantMoveOutInfoResponseDTO>;

    /**
     * Tenant submitted a planned move-out date
     * @param {TenantScheduledMoveOutRequestDTO} tenantScheduledMoveOutRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO: TenantScheduledMoveOutRequestDTO, options?: any): AxiosPromise<TenantScheduledMoveOutResponseDTO>;

    /**
     * Tenant confirming they have vacated
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    tenantVacated(token: string, options?: any): AxiosPromise<object>;

    /**
     * Update existing Property details (address or landlord) on a Tenancy
     * @param {string} id Tenancy id
     * @param {UpdateExistingPropertyOnTenancyRequestDTO} updateExistingPropertyOnTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    updateExistingProperty(id: string, updateExistingPropertyOnTenancyRequestDTO: UpdateExistingPropertyOnTenancyRequestDTO, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Update the Property On Tenancy
     * @param {string} id Tenancy id
     * @param {UpdatePropertyRequestDTO} updatePropertyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    updateProperty(id: string, updatePropertyRequestDTO: UpdatePropertyRequestDTO, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Update a Tenancy
     * @param {string} id Tenancy id
     * @param {UpdateTenancyRequestDTO} updateTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApiInterface
     */
    updateTenancy(id: string, updateTenancyRequestDTO: UpdateTenancyRequestDTO, options?: any): AxiosPromise<TenancyDTO>;

}

/**
 * TenanciesApi - object-oriented interface
 * @export
 * @class TenanciesApi
 * @extends {BaseAPI}
 */
export class TenanciesApi extends BaseAPI implements TenanciesApiInterface {
    /**
     * Update closing reminders enabled on a tenancy
     * @param {string} id Tenancy id
     * @param {UpdateClosingRemindersEnabledRequestDTO} updateClosingRemindersEnabledRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public closingRemindersEnabled(id: string, updateClosingRemindersEnabledRequestDTO: UpdateClosingRemindersEnabledRequestDTO, options?: any) {
        return TenanciesApiFp(this.configuration).closingRemindersEnabled(id, updateClosingRemindersEnabledRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Create a Tenancy
     * @param {CreateTenancyRequestDTO} createTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public createTenancy(createTenancyRequestDTO: CreateTenancyRequestDTO, options?: any) {
        return TenanciesApiFp(this.configuration).createTenancy(createTenancyRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Create a Tenancy Order
     * @param {string} id Tenancy id
     * @param {CreateOrderDTO} createOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public createTenancyOrder(id: string, createOrderDTO: CreateOrderDTO, options?: any) {
        return TenanciesApiFp(this.configuration).createTenancyOrder(id, createOrderDTO, options)(this.axios, this.basePath);
    }

    /**
     * Disable Top Ups on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public disableTopUps(id: string, options?: any) {
        return TenanciesApiFp(this.configuration).disableTopUps(id, options)(this.axios, this.basePath);
    }

    /**
     * Extend outcome deadline
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public extendOutcomeDeadline(id: string, options?: any) {
        return TenanciesApiFp(this.configuration).extendOutcomeDeadline(id, options)(this.axios, this.basePath);
    }

    /**
     * Get a Tenancy By Id
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public getTenancyById(id: string, options?: any) {
        return TenanciesApiFp(this.configuration).getTenancyById(id, options)(this.axios, this.basePath);
    }

    /**
     * Fetch all documents on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public getTenancyDocuments(id: string, options?: any) {
        return TenanciesApiFp(this.configuration).getTenancyDocuments(id, options)(this.axios, this.basePath);
    }

    /**
     * Publish products on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public publish(id: string, options?: any) {
        return TenanciesApiFp(this.configuration).publish(id, options)(this.axios, this.basePath);
    }

    /**
     * Sign addendum on a tenancy
     * @param {string} id Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public signAddendumForSupplier(id: string, options?: any) {
        return TenanciesApiFp(this.configuration).signAddendumForSupplier(id, options)(this.axios, this.basePath);
    }

    /**
     * Look up move-out flow context for a tenancy token
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public tenantMoveOutInfo(token: string, options?: any) {
        return TenanciesApiFp(this.configuration).tenantMoveOutInfo(token, options)(this.axios, this.basePath);
    }

    /**
     * Tenant submitted a planned move-out date
     * @param {TenantScheduledMoveOutRequestDTO} tenantScheduledMoveOutRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO: TenantScheduledMoveOutRequestDTO, options?: any) {
        return TenanciesApiFp(this.configuration).tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Tenant confirming they have vacated
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public tenantVacated(token: string, options?: any) {
        return TenanciesApiFp(this.configuration).tenantVacated(token, options)(this.axios, this.basePath);
    }

    /**
     * Update existing Property details (address or landlord) on a Tenancy
     * @param {string} id Tenancy id
     * @param {UpdateExistingPropertyOnTenancyRequestDTO} updateExistingPropertyOnTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public updateExistingProperty(id: string, updateExistingPropertyOnTenancyRequestDTO: UpdateExistingPropertyOnTenancyRequestDTO, options?: any) {
        return TenanciesApiFp(this.configuration).updateExistingProperty(id, updateExistingPropertyOnTenancyRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update the Property On Tenancy
     * @param {string} id Tenancy id
     * @param {UpdatePropertyRequestDTO} updatePropertyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public updateProperty(id: string, updatePropertyRequestDTO: UpdatePropertyRequestDTO, options?: any) {
        return TenanciesApiFp(this.configuration).updateProperty(id, updatePropertyRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update a Tenancy
     * @param {string} id Tenancy id
     * @param {UpdateTenancyRequestDTO} updateTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public updateTenancy(id: string, updateTenancyRequestDTO: UpdateTenancyRequestDTO, options?: any) {
        return TenanciesApiFp(this.configuration).updateTenancy(id, updateTenancyRequestDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenanciesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Update closing reminders enabled on a tenancy
 * @param {string} id Tenancy id
 * @param {UpdateClosingRemindersEnabledRequestDTO} updateClosingRemindersEnabledRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function closingRemindersEnabled(
    id: string,
    updateClosingRemindersEnabledRequestDTO: UpdateClosingRemindersEnabledRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).closingRemindersEnabled(id, updateClosingRemindersEnabledRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a Tenancy
 * @param {CreateTenancyRequestDTO} createTenancyRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createTenancy(
    createTenancyRequestDTO: CreateTenancyRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).createTenancy(createTenancyRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a Tenancy Order
 * @param {string} id Tenancy id
 * @param {CreateOrderDTO} createOrderDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createTenancyOrder(
    id: string,
    createOrderDTO: CreateOrderDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).createTenancyOrder(id, createOrderDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Disable Top Ups on a tenancy
 * @param {string} id Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function disableTopUps(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).disableTopUps(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Extend outcome deadline
 * @param {string} id Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function extendOutcomeDeadline(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).extendOutcomeDeadline(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Tenancy By Id
 * @param {string} id Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyWithCheckoutAndClaimDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).getTenancyById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Fetch all documents on a tenancy
 * @param {string} id Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyDocuments(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<PolicyDocumentDTO>> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).getTenancyDocuments(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Publish products on a tenancy
 * @param {string} id Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function publish(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).publish(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Sign addendum on a tenancy
 * @param {string} id Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function signAddendumForSupplier(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).signAddendumForSupplier(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Look up move-out flow context for a tenancy token
 * @param {string} token 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function tenantMoveOutInfo(
    token: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenantMoveOutInfoResponseDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).tenantMoveOutInfo(token, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Tenant submitted a planned move-out date
 * @param {TenantScheduledMoveOutRequestDTO} tenantScheduledMoveOutRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function tenantScheduledMoveOut(
    tenantScheduledMoveOutRequestDTO: TenantScheduledMoveOutRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenantScheduledMoveOutResponseDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).tenantScheduledMoveOut(tenantScheduledMoveOutRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Tenant confirming they have vacated
 * @param {string} token 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function tenantVacated(
    token: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).tenantVacated(token, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update existing Property details (address or landlord) on a Tenancy
 * @param {string} id Tenancy id
 * @param {UpdateExistingPropertyOnTenancyRequestDTO} updateExistingPropertyOnTenancyRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateExistingProperty(
    id: string,
    updateExistingPropertyOnTenancyRequestDTO: UpdateExistingPropertyOnTenancyRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).updateExistingProperty(id, updateExistingPropertyOnTenancyRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update the Property On Tenancy
 * @param {string} id Tenancy id
 * @param {UpdatePropertyRequestDTO} updatePropertyRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateProperty(
    id: string,
    updatePropertyRequestDTO: UpdatePropertyRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).updateProperty(id, updatePropertyRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a Tenancy
 * @param {string} id Tenancy id
 * @param {UpdateTenancyRequestDTO} updateTenancyRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateTenancy(
    id: string,
    updateTenancyRequestDTO: UpdateTenancyRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenanciesApiAxiosParamCreator(configuration).updateTenancy(id, updateTenancyRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

